<div class="activate-container">
  @if (loading()) {
    <p-progressSpinner></p-progressSpinner>
    <p>Activating your invite...</p>
  }

  @if (success()) {
    <i class="pi pi-check-circle success-icon"></i>
    <h2>You're in!</h2>
    <p>Your invite has been activated successfully.</p>
    <p-button
      label="Open Workspaces"
      icon="pi pi-briefcase"
      (click)="goToSpaces()">
    </p-button>
  }

  @if (error()) {
    <i class="pi pi-times-circle error-icon"></i>
    <h2>Something went wrong</h2>
    <p>{{ error() }}</p>
    <p-button
      label="Go to Workspaces"
      icon="pi pi-briefcase"
      severity="secondary"
      (click)="goToSpaces()">
    </p-button>
  }
</div>
